import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { ScriptLoaderService } from './script-loader.service';
import { MIME_TYPE_FOLDER, GoogleFileInfo } from '../models/googleFileInfo';
import { environment } from '../../environments/environment.prod';

const USE_GOOGLE = environment.useGoogle;
const CLIENT_ID = "411885949953-us3h1h4414tc2b3r2nag8cvt8bbi8nbc.apps.googleusercontent.com";
const API_KEY = "AIzaSyABwSOysAzkTFXLzW8D0NOHFIgRfxDFRsg";
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"];
var SCOPES = 'https://www.googleapis.com/auth/drive';

declare var UploaderForGoogleDrive;

@Injectable()
export class GapiServiceService {

  googleAuth: gapi.auth2.GoogleAuth;
  appRootFolder:GoogleFileInfo;
  private appRootFolderName ='ddAppStore';
  googleAuthResponse: gapi.auth2.AuthResponse;

  constructor(private scriptLoader: ScriptLoaderService) {
   }
   public get isGoogle(): boolean{
       return USE_GOOGLE;
   }
   public get rootFolder():GoogleFileInfo{
       if(!this.appRootFolder){
           this.initRootFolder();
       }
       return this.appRootFolder;
   }
   initClient() {  
        return new Promise((resolve,reject)=>{
            this.scriptLoader.load('googleApi').then(data=>{
                if(USE_GOOGLE){
                    gapi.load('client:auth2', () => {
                        return gapi.client.init({
                            apiKey: API_KEY,
                            clientId: CLIENT_ID,
                            discoveryDocs: DISCOVERY_DOCS,
                            scope: SCOPES,
                        }).then(() => {                   
                            this.googleAuth = gapi.auth2.getAuthInstance();
                            resolve();
                        });
                    });
                }
            });                    
        });
    }    
    initRootFolder(){

        this.exsists(this.appRootFolderName).then((isFolder:boolean)=>{
            if(!isFolder){                
                this.create('root',this.appRootFolderName).then((data)=>{
                    this.getFolder(this.appRootFolderName).then((folder)=>{
                        this.appRootFolder = folder;
                    });
                });
            }            
            else{
                this.getFolder(this.appRootFolderName).then((folder)=>{
                    this.appRootFolder = folder;
                });
            }
        });
    }
    get isSignedIn(): boolean {
        return this.googleAuth.isSignedIn.get();
    }

    signIn() {
        return this.googleAuth.signIn({
            prompt: 'consent'
        }).then((googleUser: gapi.auth2.GoogleUser) => {
            this.googleAuthResponse = googleUser.getAuthResponse();
            let user = googleUser.getBasicProfile();
            return user;
        });
    }

    signOut(): void {
        this.googleAuth.signOut();
    }

    getTokenData():gapi.auth2.AuthResponse{
        return this.googleAuthResponse;
    }

    create(parentId: string, folderName: string) {
        var folder = {
            name: folderName,
            mimeType: MIME_TYPE_FOLDER,
            parents: [parentId]
        };
        return gapi.client.drive.files.create({
            resource: folder,
            fields: "id, name, mimeType, modifiedTime, size"
        }).then((res) => {
            return GoogleFileInfo.fromGoogleFile(res.result);
        });
    }
    delete(fileId: string) {
        return gapi.client.drive.files.delete({
            fileId: fileId
        });
    }
    exsists(folderName:string){
        return gapi.client.drive.files.list({
            pageSize: 100,
            fields: "nextPageToken, files(id, name, mimeType, modifiedTime, size)",
            q: `name = '${folderName}' and trashed = false`
        }).then((res) => {
            return res.result.files.length>0;
        });        
    }
    getFolder(folderName:string){
        return gapi.client.drive.files.list({
            pageSize: 100,
            fields: "nextPageToken, files(id, name, mimeType, modifiedTime, size)",
            q: `name = '${folderName}' and trashed = false`
        }).then((res) => {
            let file: GoogleFileInfo = null;
            if(res.result.files.length>0){
                file = GoogleFileInfo.fromGoogleFile(res.result.files[0]);
            }
            return file;
        });        
    }
    getFile(fileId:string){        
        return gapi.client.drive.files.get({
            fields: "id, name, mimeType, modifiedTime, size",
            fileId:fileId
        }).then((res) => {
            return GoogleFileInfo.fromGoogleFile(res.result);
        });        
    }

    getFiles(folderId: string) {
        return gapi.client.drive.files.list({
            pageSize: 100,
            fields: "nextPageToken, files(id, name, mimeType, modifiedTime, size)",
            q: `'${folderId}' in parents and trashed = false`
        }).then((res) => {
            let files: GoogleFileInfo[] = [];
            res.result.files.forEach((file) => files.push(GoogleFileInfo.fromGoogleFile(file)));
            return files;
        });
    }

    importFile(parentId: string, file: GoogleFileInfo, onError: any, onComplete: any, onProgress: any) {
        var contentType = file.Blob.type || 'application/octet-stream';
        var metadata = {
            name: file.Blob.name,
            mimeType: contentType,
            parents: [parentId]
        };

        var uploader = new UploaderForGoogleDrive({
            file: file.Blob,
            token: gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().access_token,
            metadata: metadata,
            onError: onError,
            onComplete: onComplete,
            onProgress: onProgress,
            params: {
                convert: false,
                ocr: false
            }

        });

        uploader.upload();
    }    
}
